const getContainerStyle = (isMeta: boolean) => {
  if (isMeta) {
    return {
      background: 'white',
      pt: '27px',
      mb: '16px',
      overflow: 'hidden',
      borderRadius: 'regular', // The container in meta has a radius
    };
  }

  return {
    background: 'white',
    pb: '16px',
    pt: '27px',
  };
};

export default getContainerStyle;
